import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ViewStateContextType {
  viewState: 'form' | 'preview' | 'success' | null;
  setViewState: (state: 'form' | 'preview' | 'success' | null) => void;
}

const ViewStateContext = createContext<ViewStateContextType | undefined>(undefined);

export const ViewStateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [viewState, setViewState] = useState<'form' | 'preview' | 'success' | null>(null);

  return (
    <ViewStateContext.Provider value={{ viewState, setViewState }}>
      {children}
    </ViewStateContext.Provider>
  );
};

export const useViewState = () => {
  const context = useContext(ViewStateContext);
  if (context === undefined) {
    throw new Error('useViewState must be used within a ViewStateProvider');
  }
  return context;
};